import { Col, Divider, Row, Typography, Space, Card, message } from "antd";
import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { useNews } from "../controller/NewsController";
import { useFeedbackType } from "../../feedback/controller/FeedbackTypeController";
import { useFeedback } from "../../feedback/controller/FeedbackController";
import { useUserFeedback } from "../../feedback/controller/UserFeedbackController";
import { HeartOutlined, ShareAltOutlined, HeartFilled } from '@ant-design/icons';
import axios from "axios";
const New = () => {
    const [hidden,setHidden ] = useState(false)
    axios.interceptors.request.use(
        async (config) => {
            const access_token = localStorage.getItem("access_token");

            if (access_token) {
                config.headers = {
                    ...config.headers,
                    authorization: `Bearer ${access_token}`,
                };
            }

            return config;
        },
        (error) => Promise.reject(error)
    );

    axios.interceptors.response.use(
        response => {
            return response
        },
        function (error) {
            const access_token_url = '/access_token';
            const config = error.config
            if (
                error.response?.status === 401 &&
                config.url === access_token_url
            ) {
                // window.location.href = ('/login')
                return Promise.reject(error)
            }

            if (error.response?.status === 401 && !config._retry) {
                config._retry = true
                const refreshToken = localStorage.getItem('refresh_token')
                if (!refreshToken) setHidden(true)
                return axios
                    .post(access_token_url, {
                        refresh_token: refreshToken
                    })
                    .then(res => {
                        if (res?.status === 201) {
                            localStorage.setItem('access_token', res.data.access_token);
                            config.headers = {
                                ...config.headers,
                                authorization: `Bearer ${localStorage.getItem('access_token')}`,
                            };
                            return axios(config)
                        }
                    })
            }
            return Promise.reject(error)
        }
    )
    const { news_id } = useParams()
    const [liked, setLiked] = useState(false)
    const firstIn = useRef(true)
    const copyText = () => {
        let newHerf = window.location.href;
        navigator.clipboard.writeText(newHerf)
            .then(() => {
                message.success("網址複製成功")
            });
    }
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "get") {
            }
            else if (axiosMode === "post") {
                getNewsData({
                    news_id
                })
            }
            else if (axiosMode === "delete") {
                getNewsData({
                    news_id
                })

            }
        }
        else if (status === "error") {
            if (axiosMode === "get") {
            }
            else if (axiosMode === "post") {
                getNewsData({
                    news_id
                })
            }
            else if (axiosMode === "delete") {
                getNewsData({
                    news_id
                })
            }
        }

    }
    const getHeart =()=>{
        let feedbackTypeFirtData = feedbackTypeOption.find((ele) => ele?.feed_back_type_name === "愛心數")
        let feed_back_type_id = feedbackTypeFirtData?.feed_back_type_id
        let firt_data = NewsData.find((ele) => true)
        let news_id = firt_data?.news_id
        if( news_id && feed_back_type_id){
            getUserFeedbackOption({
                news_id,
                feed_back_type_id
            })
        }
    }
    const onClickHeart = (type) => {
        let feedbackTypeFirtData = feedbackTypeOption.find((ele) => ele?.feed_back_type_name === "愛心數")
        let feed_back_type_id = feedbackTypeFirtData?.feed_back_type_id
        let firt_data = NewsData.find((ele) => true)
        let news_id = firt_data?.news_id
        if (type === "post") {
            // setLiked(true)
            postFeedbackData(
                [{
                    news_id,
                    feed_back_type_id
                }]
            )
        }
        else {
            // setLiked(false)
            deleteFeedbackData(
                [{
                    news_id,
                    feed_back_type_id
                }]
            )
        }
    }
    const getHeartCount = () => {
        let feedbackTypeFirtData = feedbackTypeOption.find((ele) => ele?.feed_back_type_name === "愛心數")
        let feed_back_type_id = feedbackTypeFirtData?.feed_back_type_id
        let firt_data = NewsData.find((ele) => true)
        let feed_back_count_data = firt_data?.feed_back_count_data || []
        let heartData = feed_back_count_data.find((ele) => ele.feed_back_type_id === feed_back_type_id)
        let heartCount = heartData?.feed_back_count
        return heartCount || 0
    }
    const {
        NewsData,
        getNewsData,
        patchNewsclick,
    } = useNews({
        onBefore: () => { },
        onFinish: onFinish,
    })
    const {
        getFeedbackTypeOption,
        feedbackTypeOption,
    } = useFeedbackType({
        onBefore: () => { },
        onFinish: () => { },
    })
    const {
        postFeedbackData,
        deleteFeedbackData
    } = useFeedback({
        onBefore: () => { },
        onFinish: onFinish,
    })
    const {
        userFeedbackOption,
        getUserFeedbackOption
    } = useUserFeedback({
        onBefore: () => { },
        onFinish: () => { },
    })
    useEffect(() => {
        getNewsData({
            news_id
        })
        getFeedbackTypeOption()
    }, [])

    useEffect(() => {
        let firt_data = NewsData.find((ele) => true)
        let data = [
            {
                news_id: firt_data?.news_id
            }
        ]
        if (firt_data?.news_id) {
            if (firstIn.current === true) {
                patchNewsclick(data)
                firstIn.current = false
            }
        }
        getHeart()
    }, [NewsData])
    useEffect(()=>{
        getHeart()
    },[feedbackTypeOption])
    return (
        <Row justify={"center"} gutter={[32, 32]}>
            <Col span={24}>
            </Col>
            <Col xxl={20} xl={20} lg={20} md={20} sm={24} xs={24}>
                <Card>
                    <Row justify={[4, 4]}>
                        <Col span={24}>
                            <Row justify={"center"}>
                                <Col>
                                    <Typography.Title level={4}
                                        style={{
                                            padding: '0px',
                                            margin: 0
                                        }}
                                    >
                                        {NewsData.find((ele) => true)?.news_title}
                                    </Typography.Title>

                                </Col>
                            </Row>
                        </Col>
                        <Divider
                            style={{
                                margin: '12px'
                            }}
                        />
                        <Col span={24}>
                            <Row justify={"center"}>
                                <Col>
                                    <div dangerouslySetInnerHTML={{ __html: `${NewsData.find((ele) => true)?.news_content}` }}></div>
                                </Col>
                            </Row>
                        </Col>
                        <Col span={24} hidden ={hidden}>
                            <Space>
                                {userFeedbackOption.length>0 ?
                                    <HeartFilled
                                        style={{
                                            fontSize: '20px',
                                            color: '#FF5C5C'
                                        }}
                                        onClick={() => {
                                            onClickHeart("delete")
                                        }}
                                    />
                                    :
                                    <HeartOutlined
                                        style={{
                                            fontSize: '20px',
                                            color: '#FF5C5C'
                                        }}
                                        onClick={() => {
                                            onClickHeart("post")
                                        }}
                                    />

                                }
                                <ShareAltOutlined
                                    style={{
                                        fontSize: '20px',
                                    }}
                                    onClick={() => { copyText() }}
                                />
                            </Space>
                        </Col>
                        <Col>
                            <Space>
                                <div>{getHeartCount()}人喜歡</div>
                                <div>{NewsData.find((ele) => true)?.click_num ?? 0}次瀏覽</div>
                            </Space>

                        </Col>
                        <Col>

                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>
    )
}
export default New